// console.clear()
// Original Variant Selector

function getVariantParamValue() {
  const urlParams = new URLSearchParams(window.location.search);
  const variant = urlParams.get('variant');
  
  return variant;
}

function setSelectOptionIfValueExists() {
  const variantValue = getVariantParamValue();
  
  const selectElement = document.querySelector('[data-promotion-original-variant-selector]');
  
  if (selectElement && variantValue) {
    let optionExists = false;
    
    for (let option of selectElement.options) {
      if (option.value === variantValue) {
        optionExists = true;
        break;
      }
    }
    
    if (optionExists) {
      selectElement.value = variantValue;
    } else {
      console.log("The specified variant value does not exist in the select options.");
    }
  }
}

document.querySelectorAll('[data-swatch-item]').forEach((el) => {
  el.addEventListener('click', (e) => {
    setTimeout(() => {
      const variantValue = getVariantParamValue();
      if(document.querySelector('[data-promotion-original-variant-selector]')) {
        
        setSelectOptionIfValueExists();
        
        var event = new Event('change', {
          'bubbles': true,
          'cancelable': true
        });
        
        document.querySelector('[data-promotion-original-variant-selector]').dispatchEvent(event);
      }
    }, 500)
  })
})

if(getVariantParamValue()) {
  setSelectOptionIfValueExists();
}
if(document.querySelector('[data-promotion-original-variant-selector]')) {
  document.querySelector('[data-promotion-original-variant-selector]').addEventListener('change', (e) => {
      e.target.closest('[data-promotion-drawer-current-product]').setAttribute('data-promotion-drawer-current-product', e.target.value)
      _updatePromotionOriginalMetafield(e.target.value, e.target.closest('[data-promotion-drawer-current-product]'))
  })
}

function _updatePromotionOriginalMetafield(currentVariant, container) {
  
  container.querySelectorAll('[data-promotion-original-variant-toggle]').forEach((el) => {
    el.style.display = "none";
  })
  container.querySelectorAll(`[data-promotion-original-variant-toggle="${currentVariant}"]`).forEach((el) => {
    el.style.display = "block";
  })
}

// Variant Selector

document.querySelectorAll('[data-promotion-variant-selector]').forEach((el) => {
  el.addEventListener('change', (e) => {
    let buttonToAddTo = e.target.closest('[data-promotion-buy-card]').querySelector('[data-promotion-drawer-upsell-product]')
    _updatePromotionMetafield(e.target.value, buttonToAddTo.getAttribute('data-promotion-drawer-upsell-product'), e.target.closest('[data-promotion-buy-card]'))
    buttonToAddTo.setAttribute('data-promotion-drawer-upsell-product', e.target.value)
  })
})

function _updatePromotionMetafield(currentVariant, oldVariant, container) {
    if (!currentVariant || currentVariant == oldVariant) return;
    
    container.querySelectorAll('[data-promotion-variant-toggle]').forEach((el) => {
      el.style.display = "none";
    })
    container.querySelectorAll(`[data-promotion-variant-toggle="${currentVariant}"]`).forEach((el) => {
      el.style.display = "block";
    })
 }


// Add To Cart

function addPromotionToCart (current, original) {
  let formData = {
    'items': [
      {
        'id': current,
        'quantity': 1
      },
      {
        'id': original,
        'quantity': 1
      },
    ]
  };
  
  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
  .then(response => {
    closePromotionDrawer()
    T4SThemeSP.Cart.getToFetch();
    setTimeout(() => {
      document.querySelector(".t4s-site-nav__cart a").click()
    }, 700)
    return response.json();
  })
  .catch((error) => {
    console.error('Error:', error);
  });
}

let currentUpsellVariant = ""
let originalUpsellVariant = ""
let buyCards = document.querySelectorAll('[data-promotion-buy-card]')
if(buyCards && buyCards.length > 0)
{
  buyCards.forEach((item) => {
    item.querySelector('[data-promotion-drawer-upsell-product]').addEventListener('click', (e) => {
      currentUpsellVariant = e.target.getAttribute('data-promotion-drawer-upsell-product')
      originalUpsellVariant = document.querySelector('[data-promotion-drawer-current-product]').getAttribute('data-promotion-drawer-current-product')
      addPromotionToCart(currentUpsellVariant, originalUpsellVariant)
    })
  })
}



// Logic for Drawer

let promotionBanners = document.querySelectorAll('[data-promotion-banner]');
let promotionDrawer = document.querySelector('[data-drawer-promotion]')

if(promotionBanners && promotionBanners.length > 0)
{ 
  promotionBanners.forEach((item) => {
    item.addEventListener('click', () => {
      document.querySelector('.promotionXY-drawer').style.opacity = 1
      document.querySelector('.promotionXY-drawer').style.pointerEvents = 'all'
      setTimeout(() => {
        document.querySelector('.promotionXY-drawer-wrapper').style.transform = 'translateX(0)'
      }, 200)
    })
  })

  
  let promotionClose = document.querySelector('[data-drawer-close-promotion]')
  let promotionOverlay = document.querySelector('[data-drawer-overlay-promotion]')
  
  function closePromotionDrawer() {
    document.querySelector('.promotionXY-drawer-wrapper').style.transform = 'translateX(100%)'
    setTimeout(() => {
      document.querySelector('.promotionXY-drawer').style.opacity = 0
      document.querySelector('.promotionXY-drawer').style.pointerEvents = 'none'
    }, 200)
  }
  
  promotionClose.addEventListener('click', () => {
    closePromotionDrawer()
  })
  promotionOverlay.addEventListener('click', () => {
    closePromotionDrawer()
  })
}
